import { Component, Input, OnInit } from '@angular/core';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationState, WorkflowData } from '../../../../../applications/models/applications.models';
import { AuthService } from '../../../../../services/auth.service';

@Component({
    selector: 'app-initial-production',
    templateUrl: './initial-production.component.html',
    styleUrls: ['./initial-production.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class InitialProductionComponent extends ApplicationSectionBaseComponent implements OnInit {
    @Input() application: WorkflowData;



    get isInternal(): boolean {
        return this._auth.User.isInternal;
    }


    constructor(public _auth: AuthService) {
        super(_auth);
    }

    ngOnInit() {

        if (this.application != null) {

        if (this.application.applicationState == (ApplicationState.InitialReview || ApplicationState.Approved)) {
            this.form.disable()
            }

            if (this.isInternal && this.application.applicationState == ApplicationState.Corrections) {
                this.form.disable();
            }

        }
  }

}
